export const SET_SHOW_SKIP_INTRO = "SET_SHOW_SKIP_INTRO";
export const SET_SKIP_INTRO_VALUES = "SET_SKIP_INTRO_VALUES";
export const CLEAR_SKIP_INTRO_CONFIG = "CLEAR_SKIP_INTRO_CONFIG";